import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a488f10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "buy__form--header" }, "Ordering", -1 /* HOISTED */))
const _hoisted_2 = { class: "buy__form--info" }
const _hoisted_3 = { class: "personal-info" }
const _hoisted_4 = { class: "buy__success" }

import { useModal } from '@/store';
import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import ModalPayment from '@/components/modal/ModalPayment.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWindow',
  setup(__props) {

const modalStore = useModal();
const { modalIsShow, orderIsCompleted, buyAttemt } = storeToRefs(modalStore);

const closeModal = (): void => {
  modalStore.$reset();
  modalIsShow.value = false;
  buyAttemt.value = false;
};

watch(modalIsShow, (newModalIsShow) => {
  document.body.style.overflow = newModalIsShow ? 'hidden' : 'auto';
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AppInput = _resolveComponent("AppInput")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-anime" }, {
      default: _withCtx(() => [
        (_unref(modalIsShow))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "buy",
              onMousedown: closeModal
            }, [
              _withDirectives(_createElementVNode("section", {
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                class: "buy__form"
              }, [
                _createElementVNode("span", {
                  class: "buy__form--close",
                  onClick: closeModal
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                ]),
                _hoisted_1,
                _createElementVNode("section", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_AppInput, { field: 'fullName' }),
                    _createVNode(_component_AppInput, { field: 'phone' }),
                    _createVNode(_component_AppInput, { field: 'adress' }),
                    _createVNode(_component_AppInput, { field: 'email' })
                  ]),
                  _createVNode(ModalPayment)
                ])
              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vShow, !_unref(orderIsCompleted)]
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_4, "Order successfully completed!", 512 /* NEED_PATCH */), [
                [_vShow, _unref(orderIsCompleted)]
              ])
            ], 32 /* HYDRATE_EVENTS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})